module.exports = __webpack_public_path__ + "/images/ico-round-corazon.160ca42.svg";